import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';

const LoadingLeaf = () => {
  return (
    <div data-testid="loading" id="loading">
      <CircularProgress color="primary" />
    </div>
  );
};

export default LoadingLeaf;
